import React, { FC } from 'react';
import { Description } from './styled';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import RegistrationPricing from 'containers/pages/home-page/components/opportunities/RegistrationPricing';
import {
    Pricing,
    Discount,
    NoDiscount,
    CardListItemText,
    CardListItem,
    CardList,
} from 'containers/pages/home-page/components/opportunities/styled';

const RegistrationDescription: FC = () => {
    const { t } = useTranslation('pages/action-page');

    return (
        <Description>
            <p
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(t('reg-description')),
                }}
            />
            <RegistrationPricing noMargin />
            <Pricing noMargin>
                <Discount>{t('alumni-discount')}</Discount>
                <NoDiscount>{t('opp-no-discount')}</NoDiscount>
                <CardListItemText>
                    <span>{t('alumni-discount-desc')}</span>
                </CardListItemText>
            </Pricing>
            <Pricing noMargin>
                <Discount>{t('alumni-discount1')}</Discount>
                <NoDiscount>{t('opp-no-discount')}</NoDiscount>
                <CardListItemText>
                    <span>{t('alumni-discount-desc1')}</span>
                </CardListItemText>
            </Pricing>
            <br />
            <br />

            <CardList noBorder>
                <CardListItem>
                    <CardListItemText>
                        {t('alumni-description-title')}
                        <br />
                        <span
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(t('alumni-description-desc')),
                            }}
                        />
                    </CardListItemText>
                </CardListItem>
                <br />
                <br />
                <CardListItem>
                    <CardListItemText>
                        {t('alumni-description-title1')}
                        <br />
                        <span
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(t('alumni-description-desc1')),
                            }}
                        />
                    </CardListItemText>
                </CardListItem>
            </CardList>
        </Description>
    );
};

export default RegistrationDescription;
